<template>
    <v-radio-group
        v-if="elements && elements.length > 0"
        :rules="isMandatory ? rules : []"
        :error="error"
        v-model="radioGroup"
    >
        <v-radio
            v-for="(element, index) in elements"
            :key="index + element.id"
            :label="element.text"
            :value="element.text"
        ></v-radio>
    </v-radio-group>
</template>

<script>
export default {
    props: {
        elements: {
            type: Array,
            // Quitamos el required: true o ponemos un default para evitar el warning de Vue
            default: () => []
        }
    },
    data() {
        return {
            error: false,
            // PROTECCIÓN: Verificamos que elements exista y sea array antes del .find
            radioGroup: null
        }
    },
    // Usamos created para inicializar el valor de forma segura
    created() {
        if (this.elements && Array.isArray(this.elements)) {
            const selected = this.elements.find(element => element.answer === true);
            this.radioGroup = selected ? selected.text : null;
        }
    },
    watch: {
        radioGroup() {
            this.setValues();
        },
        // IMPORTANTE: Si los elementos cambian (al pasar de página), actualizamos el radioGroup
        elements: {
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    const selected = newVal.find(element => element.answer === true);
                    this.radioGroup = selected ? selected.text : null;
                }
            },
            deep: true
        }
    },
    computed: {
        rules() {
            return [
                v => !!v || this.$t("signer_form.required_field")
            ];
        },
        // Simplificamos la lógica de obligatorio
        isMandatory() {
            return this.elements && this.elements.length > 0 && this.elements[0].mandatory;
        }
    },
    methods: {
        setValues() {
            if (!this.elements) return;

            let answeredElements = [...this.elements];

            answeredElements.forEach((element, index) => {
                answeredElements[index].answer = (element.text === this.radioGroup);
            });

            this.emitAnswerUpdate(answeredElements);
        },
        emitAnswerUpdate(answeredElements) {
            this.$emit('answer-updated', answeredElements, true);
        },
        validateField() {
            this.error = false;

            if (this.isMandatory) {
                if (!this.radioGroup) {
                    this.error = true;
                    return false;
                }
            }

            return true;
        }
    },
};
</script>